/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import { ColumnResizer as i } from "@progress/kendo-react-data-tools";
import { GridContext as u } from "../../utils/GridContext.mjs";
const R = (o) => {
  const { column: t } = o, e = r.useContext(u);
  return e.columnResizeRef.current && e.columnResizeRef.current.resizable && t.resizable && /* @__PURE__ */ r.createElement(
    i,
    {
      key: 2,
      resize: (n, c, l) => e.columnResizeRef.current && e.columnResizeRef.current.dragHandler(n, t, c, l),
      autofit: (n) => e.columnResizeRef.current && e.columnResizeRef.current.dblClickHandler(n, [t.id])
    }
  ) || /* @__PURE__ */ r.createElement(r.Fragment, null);
};
export {
  R as HeaderCellResizer
};
